import { observer } from 'mobx-react-lite'
import React from 'react'

import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { RingFirstDropdown } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/Ring/ui/RingActionEditContent/RingFirstDropdown/RingFirstDropdown'
import { UsersMultiDropdown } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/Ring/ui/RingActionEditContent/UsersMultiDropdown/UsersMultiDropdown'
import styles from './styles.module.scss'
import { type RingStore } from '../../store/RingStore'

type IActionEditContentProps = {
  store: RingStore
}

export const RingActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const {
    ringFirstDropdownStore,
    usersMultiDropdownStore,
    duration,
    setDuration,
    durationItems,
    isUsersSelect,
  } = store

  return (
    <div className={styles.wrap}>
      <RingFirstDropdown store={ringFirstDropdownStore} />
      {isUsersSelect && <UsersMultiDropdown store={usersMultiDropdownStore} />}
      <SelectField
        withSearch={false}
        labelText={'Total ring duration'}
        size={'medium'}
        items={durationItems}
        setValue={setDuration}
        value={duration}
      />
    </div>
  )
})
